import { Component, OnInit } from '@angular/core';

import { MenuItem } from 'primeng/api';


@Component ( {
                 selector   : 'app-fleet-finder',
                 templateUrl: './fleet-finder.component.html',
                 styleUrls  : [ './fleet-finder.component.scss' ]
             } )

export class FleetFinderComponent implements OnInit
{
    private readonly _steps_: Array <MenuItem>
    private _currentIndex_: number;
    private _displaySteps_: boolean;
    
    public get currentIndex (): number
    {
        return ( this._currentIndex_ );
    }
    
    public set currentIndex ( index: number )
    {
        this._currentIndex_ = index;
    }
    
    public get displaySteps (): boolean
    {
        return ( this._displaySteps_ );
    }
    
    public get steps (): Array <MenuItem>
    {
        return ( this._steps_ );
    }
    
    constructor ()
    {
        const additionalInfoStep: MenuItem = { label: 'Additional Information', routerLink: 'additional-info', disabled: true  };
        const contactInfoStep   : MenuItem = { label: 'Contact Information',    routerLink: 'contact-info',    disabled: true  };
        const resultsStep       : MenuItem = { label: 'Results',                routerLink: 'results',         disabled: true  };
        const reviewSubmitStep  : MenuItem = { label: 'Review & Submit',        routerLink: 'review-submit',   disabled: true  };
        const selectProductStep : MenuItem = { label: 'Select Product',         routerLink: 'select-product',  disabled: false };
        
        this._currentIndex_ = 0;
        this._displaySteps_ = false;
        this._steps_        = [ selectProductStep,
                                resultsStep,
                                additionalInfoStep,
                                contactInfoStep,
                                reviewSubmitStep ];
    }
    
    ngOnInit (): void
    {
        this._currentIndex_ = 0;
    }
}
